
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/x-boost",
      function () {
        return require("private-next-pages/x-boost/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/x-boost"])
      });
    }
  